import { useEffect, useState } from "react";

// must be the same as in tailwind.confi.js
const tailwindScreen = {
  sm: 640, // phones
  md: 768, // tablets
  lg: 1024, // small desktop
  xl: 1280, //medium desktop
  xxl: 1920, //big desktop
  xxxl: 2560, //monitor
  x4k: 3840, //4k monitor
} as const;

const useScreens = (screen: "sm" | "md" | "lg" | "xl" | "xxl" | "xxxl" | "x4k", direction: "up" | "down") => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const targetScreen = tailwindScreen[screen];
  const isCorrectScreen = direction === "up" ? targetScreen < windowWidth : targetScreen > windowWidth;
  useEffect(() => {
    window.addEventListener("resize", () => {
      setWindowWidth(window.innerWidth);
    });
  }, []);
  return isCorrectScreen;
};

export default useScreens;
